import Fit from "./Fit";

const HeldUpCopy = () => {
  return <Fit />;
};
export default HeldUpCopy;
